import { searchPhraseDictionary } from "@core/global/global-country-dictionary";
import { useState, useEffect } from "react";

const AutoSuggestDropdown = ({ loading, filteredSuggestions, showSuggestions, inputValue, setSelectedData, selectedData, selectedCategory, setIsSelectedFromAutoSuggest, showLoadMore, setShowLoadMore, visibleSuggestions, setVisibleSuggestions, handleSuggestionClick, handleRedirection, searchKeyLabel, handleClearAll, setIsMatchTypeExact }) => {
  const [loadMoreClicked, setLoadMoreClicked] = useState(0);
  const tabEventExceptions = ["Product Category", "HS Code", "Chemicals"];

  useEffect(() => {
    if (filteredSuggestions?.length > 5) {
      setVisibleSuggestions(filteredSuggestions.slice(0, 5));
      setShowLoadMore(true);
    } else {
      setVisibleSuggestions(filteredSuggestions);
      setShowLoadMore(false);
    }
    setLoadMoreClicked(0);
  }, [filteredSuggestions]);

  const highlightMatch = (text, search) => {
    if (!search) return text;
    const searchedText = escapeRegExp(search);
    const regex = new RegExp(`(${searchedText})`, "gi");
    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <mark key={index} className="tw-font-medium tw-bg-transparent tw-p-0">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };
  function escapeRegExp(string = "") {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  const handleLoadMore = () => {
    setLoadMoreClicked((prev) => prev + 1);
    if (loadMoreClicked === 0) {
      setVisibleSuggestions(filteredSuggestions?.slice(0, 10));
    } else {
      setVisibleSuggestions(filteredSuggestions);
      setShowLoadMore(false);
    }
  };
  const removeSelectedData = (data) => {
    const tempSelectedData =
      selectedData?.filter((item) => {
        return item.value !== data.value;
      }) || [];
    setSelectedData(tempSelectedData);
  };

  useEffect(() => {
    setIsMatchTypeExact(selectedData.some((data) => data?.mongo_id));
  }, [selectedData]);

  return (
    ((showSuggestions && filteredSuggestions?.length >= 0) || selectedData?.length > 0) && (
      <div className={`tw-absolute tw-top-[85px] tw-z-10 tw-flex tw-items-center tw-shadow-autoSuggest tw-bg-white tw-rounded-2xl ${showSuggestions && selectedData?.length > 0 ? "tw-py-2" : "tw-py-0"}`}>
        <div className="tw-w-[600px] tw-max-h-[300px] tw-overflow-y-auto">
          {selectedData?.length > 0 && (
            <div className="tw-flex tw-flex-row tw-gap-2.5 tw-px-3 tw-py-1 tw-justify-between">
              <div className="tw-flex tw-gap-x-2 tw-gap-y-4 tw-flex-wrap">
                {selectedData?.map((selected) => (
                  <div key={selected.value} className="tw-flex tw-gap-1 tw-items-center tw-rounded-[54px] tw-border tw-border-primary-purple-600 tw-shadow-autoSuggestPill tw-py-1 tw-px-2">
                    <div className="tw-text-xs tw-text-gray-900 tw-text-nowrap tw-max-w-[120px] tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis">{selected?.label}</div>
                    <div
                      className="tw-cursor-pointer"
                      onClick={() => {
                        removeSelectedData(selected);
                      }}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#000">
                        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
              <span onClick={handleClearAll} className="tw-text-sm tw-font-medium tw-text-primary-purple-600 tw-cursor-pointer">
                Clear
              </span>
            </div>
          )}
          {selectedData?.length > 0 && visibleSuggestions?.length > 0 && <div className="tw-w-ful tw-border-t tw-mt-1"></div>}
          {Array.isArray(visibleSuggestions) &&
            visibleSuggestions?.map((suggestion, index) => (
              <div
                key={index}
                onClick={() => {
                  handleSuggestionClick(suggestion);
                  setIsSelectedFromAutoSuggest(true);
                  if (suggestion?.mongo_id || selectedCategory === "product_hscode") {
                    handleRedirection(suggestion);
                  }
                }}
                className="tw-px-3 tw-py-1 tw-text-sm hover:tw-bg-primary-purple-50 tw-cursor-pointer tw-flex tw-justify-between tw-items-center">
                <span>{highlightMatch(suggestion?.label, inputValue)}</span>
                {inputValue === suggestion?.label && !tabEventExceptions.includes(searchKeyLabel.label) && <span className="tw-text-gray-400 tw-text-xs">or press Tab</span>}
              </div>
            ))}
          {loading && visibleSuggestions?.length === 0 && (inputValue !== "" || selectedCategory === searchPhraseDictionary.product_category) && <span className="tw-text-sm tw-text-gray-900 tw-font-medium tw-px-3">Loading...</span>}
          {selectedCategory !== searchPhraseDictionary.product_category && selectedCategory !== searchPhraseDictionary.product_hscode && Array.isArray(visibleSuggestions) && (visibleSuggestions.length === 0 || !visibleSuggestions.some((item) => item.label.trim().toLowerCase() === inputValue.trim().toLowerCase()) || (visibleSuggestions.length > 0 && visibleSuggestions.every((item) => !item.label.trim().toLowerCase().includes(inputValue.trim().toLowerCase())))) && inputValue !== "" && (selectedData ? !selectedData.some((item) => item.label.trim().toLowerCase() === inputValue.trim().toLowerCase()) : true) && (
            <div
              onClick={() => {
                handleSuggestionClick({ label: inputValue, value: inputValue });
              }}
              className="tw-px-3 tw-py-1 tw-text-sm hover:tw-bg-primary-purple-50 tw-cursor-pointer tw-flex tw-justify-between tw-items-center">
              <span>Add new: {highlightMatch(inputValue, inputValue)}</span>
              {!tabEventExceptions.includes(searchKeyLabel.label) && <span className="tw-text-gray-400 tw-text-xs">or press Tab</span>}
            </div>
          )}
          {showLoadMore && (
            <div onClick={handleLoadMore} className="tw-py-2 tw-text-sm tw-text-primary-purple-500 tw-cursor-pointer tw-border-t tw-font-medium tw-sticky tw-bottom-0 tw-bg-white">
              <span className="tw-px-3">Load More</span>
            </div>
          )}
          {!loading && inputValue !== "" && visibleSuggestions?.length === 0 && selectedData.find((item) => item.label === inputValue.trim()) && selectedCategory !== searchPhraseDictionary.product_hscode && selectedCategory !== searchPhraseDictionary.product_category && <span className="tw-text-sm tw-text-gray-900 tw-font-medium tw-px-3">No results found</span>}
        </div>
      </div>
    )
  );
};

export default AutoSuggestDropdown;
